import { ScrollSaver } from "./ScrollSaver";
import { isTtIntegrationMessage, parseMessage } from "../utils";

export const createMessageHandler = (scrollSaver: ScrollSaver) => (event: MessageEvent) => {
    if (!isTtIntegrationMessage(event)) return;
    const { newPath } = parseMessage(event);
    scrollSaver.saveCurrentScroll().setCurrentPath(newPath).scrollForCurrent();
};
